import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useEntityContext } from "../../../context/EntityContext";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import ProCode from "../../StateMachine/ProCode";
import EntityForm from "../components/EntityForm";
import EntityJobs from "../components/EntityJobs";
import EntitySettings from "../components/EntitySetting";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import NotesAndTags from "../../../components/BuilderComponents/NotesAndTags";
import Button from "../../../components/FormComponents/Button";
import createFormImage from "../../../images/createForm.png";

const EntityEditor = ({ file, activitiesData, allFieldsObject }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);

  const navigate = useNavigate();
  const { appId } = useParams();

  const {
    selectedEntitySm,
    allProCode,
    setAllProCode,
    entityUniqueField,
    entityInitData,
    setEntityInitData,
    smTriggerJobData
  } = useEntityContext();
  const { markClean, isDirty } = useDirtyChecker({
    entityUniqueField,
    entityInitData,
    smTriggerJobData,
    allProCode
  });

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(entityInitData));
    copyBlockData[keyName] = data;
    setEntityInitData(copyBlockData);
  };

  const tabData = [
    {
      label: "Forms",
      content: <EntityForm activitiesData={activitiesData} />
    },
    {
      label: "Entity Job",
      content: <EntityJobs />
    },
    {
      label: "Settings",
      content: <EntitySettings allFieldsObject={allFieldsObject} />
    },
    {
      label: "Pro Code",
      content: <ProCode allProCode={allProCode} setAllProCode={setAllProCode} tableID={selectedEntitySm.stateid} />
    }
  ];

  const getEntityConfig = () => {
    return {
      entityConfig: { unique_fields: entityUniqueField },
      smConfig: entityInitData,
      cartConfig: {
        sm_trigger_job: smTriggerJobData,
        pro_code: allProCode,
        cart_detailview: {
          elements: [],
          cart_action: {}
        }
      }
    };
  };

  const handleSaveEntity = async () => {
    try {
      setIsSaving(true);
      const config = getEntityConfig();
      await axiosInstance.put(`/state-machine/${selectedEntitySm.stateid}`, config.cartConfig);
      const { message } = await axiosInstance.put(`/entity/${file.id}`, config.entityConfig);
      await axiosInstance.put(
        `/state-machine/${selectedEntitySm.stateid}/activities/${selectedEntitySm.id}`,
        config.smConfig
      );
      toastSuccess(message || "Entity Saved Successfully");
      markClean();
    } catch (error) {
      handleApiError(error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  const handleFormNavigate = () => {
    navigate(`../../${appId}/form/${activitiesData.id}`);
  };

  return (
    <div className="page_main_section entity_main_page p_0 overflow_hidden">
      <GenericActionBar
        path={
          <div>
            <em>Entity</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "Notes",
            icon: "notes",
            title: "Add Notes",
            onClick: () => setShowNotesModal(true)
          },
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveEntity
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />
      {activitiesData?.form?.sections[0]?.fields.length > 0 ? (
        <BuilderTabs
          tabs={tabData}
          tabsClass={"activity_tab"}
          containerClass={"page-action-bar-top align-start"}
          contentClass={"h_100"}
        />
      ) : (
        <div className="add_form_container">
          <div>
            <img src={createFormImage} alt="create form" style={{ height: "381px", width: "572px" }} />
          </div>
          <div>
            <Button onClick={handleFormNavigate}>+ Add Fields</Button>
          </div>
        </div>
      )}
      <BuilderModal isOpen={showNotesModal} onClose={() => setShowNotesModal(false)} modalName="Add Notes">
        <NotesAndTags notesValue={entityInitData.description || ""} onChange={handleNotesAndTag} />
      </BuilderModal>
    </div>
  );
};

export default EntityEditor;
